export default {
  isShowLoader: state => state.isShowLoader,
  config: state => state.config
};
